import { render, staticRenderFns } from "./SensorDecoderComponent.vue?vue&type=template&id=60737654"
import script from "./SensorDecoderComponent.vue?vue&type=script&lang=js"
export * from "./SensorDecoderComponent.vue?vue&type=script&lang=js"
import style0 from "./SensorDecoderComponent.vue?vue&type=style&index=0&id=60737654&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports